import React from 'react'
import { PaginateProps } from './interface'
import Pagination from '@mui/material/Pagination'

export const Page = ({ postsPerPage, totalPosts, paginate }: PaginateProps) => {
	const pageNumbers = []
	const [p, setP] = React.useState(1)
	for (let i = 1; i <= Math.ceil(totalPosts / postsPerPage); i++) {
		pageNumbers.push(i)
	}
	const handleChange = (event: React.ChangeEvent<unknown>, value: number) => {
		paginate(value)
		setP(value)
	}
	return (
		<Pagination
			count={Math.ceil(totalPosts / postsPerPage)}
			page={p}
			onChange={handleChange}
			sx={{
				'& .Mui-selected': {
					borderRadius: '8px',
				},
				width: {sm:'50%', xs:'100%'},
				display: 'flex',
				justifyContent: 'center',
			}}
		/>
	)
}
